"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionPackageComponent = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _basketItem = require("@ori/basket-item");
var _react = require("react");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _utils = require("../../utils");
var _SectionItem = require("../SectionItem");
var _ToggleIcon = require("./ToggleIcon");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(() => ({
  position: 'relative'
}));
const PackageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.background.paper,
  border: '1px solid',
  borderRadius: theme.shape.largeComponentRadius,
  borderColor: theme.palette.grey[200],
  margin: theme.spacing(4, 0),
  overflow: 'hidden',
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(6, 0)
  }
}));
const PackageHeader = (0, _mui.styled)('div')(({
  ownerState: {
    isOpen
  },
  theme
}) => ({
  borderBottom: isOpen ? `2px solid ${theme.palette.grey[100]}` : 0,
  margin: theme.spacing(0, 3),
  padding: theme.spacing(4, 0),
  position: 'relative',
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(0, 6)
  }
}));
const PackageTitleWrapper = (0, _mui.styled)('div')(({
  ownerState: {
    isOpen
  }
}) => ({
  cursor: 'default',
  position: 'relative',
  whiteSpace: 'nowrap',
  '&:hover': {
    cursor: isOpen ? 'default' : 'pointer'
  }
}));
const PackageTitle = (0, _mui.styled)(_mui.Typography)(({
  ownerState: {
    isPostponeIconVisible
  },
  theme
}) => ({
  alignItems: 'center',
  display: 'inline-flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(1),
  maxWidth: isPostponeIconVisible ? 'calc(100% - 50px)' : '100%',
  minHeight: 24,
  color: theme.palette.grey[900],
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(2)
  }
}));
const TitleExpandButton = (0, _mui.styled)(_ToggleIcon.ToggleIcon)(({
  theme
}) => ({
  marginLeft: theme.spacing(1)
}));
const HeaderDetail = (0, _mui.styled)('span')(({
  theme
}) => ({
  margin: theme.spacing(0, 1)
}));
const PostponeButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  marginLeft: theme.spacing(1),
  position: 'absolute',
  right: theme.spacing(0),
  top: theme.spacing(2),
  '&:hover': {
    background: theme.palette.background.paper
  }
}));
const PackageFooter = (0, _mui.styled)('div')(({
  ownerState: {
    isOpen
  },
  theme
}) => ({
  borderTop: `2px solid ${theme.palette.grey[100]}`,
  color: theme.palette.text.secondary,
  cursor: 'default',
  display: 'flex',
  flexDirection: 'row',
  fontSize: '1.3rem',
  fontWeight: 'bold',
  padding: theme.spacing(2, 0),
  margin: theme.spacing(0, 3),
  '&:hover': {
    cursor: isOpen ? 'default' : 'pointer'
  },
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(0, 6)
  }
}));
const TotalValues = (0, _mui.styled)('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%'
}));
const TotalBp = (0, _mui.styled)('span')(({
  theme
}) => ({
  fontWeight: 'normal',
  marginRight: theme.spacing(7),
  right: theme.spacing(20)
}));
const PriceWrapper = (0, _mui.styled)('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end'
}));
const HighlightPrice = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.offer.main,
  fontSize: _constants.BODY2_FONT_SIZE,
  fontWeight: 'bold'
}));
const TotalPriceOriginal = (0, _mui.styled)('span')(({
  theme
}) => ({
  color: theme.palette.text.disabled,
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 'normal',
  textAlign: 'right',
  textDecoration: 'line-through'
}));
const CancelSubscriptionButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  background: theme.palette.primary.contrastText,
  border: 'none',
  boxShadow: _mui.SHADOW_LEVEL1,
  height: 35,
  padding: theme.spacing(1),
  position: 'absolute',
  top: theme.spacing(-3),
  width: 35,
  '&:active': {
    background: theme.palette.grey[200]
  },
  '&:hover': {
    background: theme.palette.primary.contrastText
  },
  [theme.breakpoints.up('md')]: {
    left: theme.spacing(3)
  }
}));
const SubscriptionPackageComponent = ({
  'data-testid': testId,
  customerId,
  cycle,
  isDelayAllowed,
  isExpanded,
  items,
  packageId,
  packageName,
  placement,
  step,
  subscriptionId,
  subscriptionItemInfo,
  totalBp,
  totalPrice,
  totalPriceOriginal
}) => {
  const [isOpen, setIsOpen] = (0, _react.useState)(isExpanded);
  const {
    isSimplifiedCheckout
  } = (0, _contexts.useCheckoutBasket)();
  const handleOpen = (0, _react.useCallback)(() => {
    setIsOpen(true);
  }, [setIsOpen]);
  const ownerState = {
    isOpen
  };
  const handleDelaySubscription = (0, _react.useCallback)(async () => {
    try {
      await (0, _utils.delaySubscription)({
        subscriptionId,
        step,
        cycle
      });
    } catch (error) {
      (0, _utils.showErrorNotification)('genericError');
      _logger.mainLogger.error(error);
    }
  }, [subscriptionId, step, cycle]);
  const onDelaySubscriptionClick = (0, _react.useCallback)(async () => {
    await handleDelaySubscription();
  }, [handleDelaySubscription]);
  const handleCancelSubscription = (0, _react.useCallback)(async () => {
    try {
      await (0, _utils.cancelSubscription)(customerId, subscriptionId, packageId);
    } catch (error) {
      (0, _utils.showErrorNotification)('genericError');
      _logger.mainLogger.error(error);
    }
  }, [customerId, subscriptionId, packageId]);
  const onCancelSubscriptionClick = (0, _react.useCallback)(async () => {
    await handleCancelSubscription();
  }, [handleCancelSubscription]);
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const isPostponeIconVisible = isDelayAllowed && isOpen && Boolean(subscriptionId);
  const mapperProps = (0, _react.useMemo)(() => ({
    isBundleItem: false,
    isSubscription: true,
    isOfferItem: false,
    testId
  }), [testId]);
  const actionsProps = (0, _react.useMemo)(() => ({
    placement,
    subscriptionId,
    subscriptionItemInfo
  }), [placement, subscriptionId, subscriptionItemInfo]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(PackageWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(PackageHeader, {
        ownerState: ownerState,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(PackageTitleWrapper, {
          ownerState: ownerState,
          onClick: handleOpen,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(PackageTitle, {
            noWrap: true,
            ownerState: {
              isPostponeIconVisible
            },
            variant: "body1",
            children: [packageName, ' ', !isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(TitleExpandButton, {
              color: "default",
              ownerState: {
                isOpen
              },
              variant: "text",
              "aria-label": formatMessage('openList'),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {})
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
            variant: "body1",
            children: [cycle ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(HeaderDetail, {
              children: [formatMessage('cycle'), ": ", cycle]
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(HeaderDetail, {
              children: [formatMessage('step'), ": ", step]
            })]
          })]
        }), isPostponeIconVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(PostponeButton, {
          color: "default",
          title: formatMessage('postpone'),
          variant: "contained",
          "aria-label": formatMessage('postpone'),
          onClick: onDelaySubscriptionClick,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Delay, {})
        }) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: isOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_basketItem.BasketSection, {
          overrideMdMaxWidth: isSimplifiedCheckout ? undefined : `${_constants.MAX_WIDTH}px`,
          children: items.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionItem.SectionItem, {
            item: item,
            mapperProps: mapperProps,
            actionsProps: actionsProps
          }, `subscription-item-${item.itemCode}-${item.itemType}-${item.lineNumber}-${item.totalPrice}`))
        }) : null
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(PackageFooter, {
        ownerState: ownerState,
        onClick: handleOpen,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          children: [formatMessage('total'), ":"]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(TotalValues, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(TotalBp, {
            children: formatMessage('bpCount', {
              0: totalBp
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PriceWrapper, {
            children: totalPrice === totalPriceOriginal ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: totalPrice
            }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(HighlightPrice, {
                children: totalPrice
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(TotalPriceOriginal, {
                children: totalPriceOriginal
              })]
            })
          })]
        })]
      })]
    }), subscriptionId === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(CancelSubscriptionButton, {
      onClick: onCancelSubscriptionClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
        fontSize: "inherit"
      })
    })]
  });
};
exports.SubscriptionPackageComponent = SubscriptionPackageComponent;